import type { ReactNode } from 'react'

type Props = {
  readonly children: ReactNode
}

/**
 * Badge component
 *
 * @returns JSX.Element | null
 */
export function Badge({ children }: Props) {
  return children ? (
    <div className="inline-block mr-3">
      <div className="grow border-neutral-black bg-primary-100 rounded-md border border-solid uppercase font-medium md:py-0 p-1 text-xs md:text-lg">
        {children}
      </div>
    </div>
  ) : null
}
